import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ProfissionalService {
  url: string = `${environment.url}/professionals`;

  constructor(private http: HttpClient) {}

  getById(id: number | string) {
    return this.http
      .get(`${this.url}/${id}`)
      .pipe(map((res: any) => res)) as Observable<any[]>;
  }

  get() {
    return this.http
      .get(this.url)
      .pipe(map((res: any) => res['hydra:member'])) as Observable<any[]>;
  }

  post(req: any) {
    return this.http.post(this.url, req) as Observable<any>;
  }
  edit(req: any, id: number) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/merge-patch+json',
    });
    return this.http.patch(`${this.url}/${id}`, req, {
      headers: headers,
    }) as Observable<any>;
  }

  delete(id: number) {
    return this.http.delete(`${this.url}/${id}`) as Observable<any>;
  }

   getURLFile(file: string) {
    return this.http.get(`${environment.url}/s3/download`, {
      params: {
        file
      },
      responseType: 'blob'
    })
  }
}
